export default "__VITE_ASSET__uW5N4s9P__"